export default __webpack_public_path__ + "static/session-formula-dark-mode-864170a4f05c4573f36e6969ed67d218.png";